import { Column, Entity, JoinColumn, OneToOne, PrimaryGeneratedColumn } from "typeorm";
import { PARequestListEntity } from "./pa-request-list-entity";

@Entity('pa_request_sub')
export class PARequestChildEntity {

    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column({ name: 'factory_answer_jdg_rslt', type: 'varchar', length: 30, nullable: true })
    factoryAnswerJdgRslt: string;

    @Column({ name: 'factory_answer_psbl_ph', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPsblPh: string;

    @Column({ name: 'factory_answer_psbl_wh_ship', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPsblWhShip: string;

    @Column({ name: 'factory_answer_psbl_wh_air', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPsblWhAir: string;

    @Column({ name: 'factory_answer_min_qty', type: 'varchar', length: 30, nullable: true })
    factoryAnswerMinQty: string;

    @Column({ name: 'factory_answer_psbl_qty', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPsblQty: string;

    @Column({ name: 'factory_answer_yarn_dl', type: 'varchar', length: 30, nullable: true })
    factoryAnswerYarnDl: string;

    @Column({ name: 'factory_answer_fabric_dl', type: 'varchar', length: 30, nullable: true })
    factoryAnswerFabricDl: string;

    @Column({ name: 'factory_answer_color_dl', type: 'varchar', length: 30, nullable: true })
    factoryAnswerColorDl: string;

    @Column({ name: 'factory_answer_trim_dl', type: 'varchar', length: 30, nullable: true })
    factoryAnswerTrimDl: string;

    @Column({ name: 'factory_answer_po_dl', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPoDl: string;

    @Column({ name: 'factory_answer_exf', type: 'varchar', length: 30, nullable: true })
    factoryAnswerExf: string;

    @Column({ name: 'factory_answer_bd_exf', type: 'varchar', length: 30, nullable: true })
    factoryAnswerBdExf: string;

    @Column({ name: 'factory_answer_po_exf', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPoExf: string;

    @Column({ name: 'factory_answer_prd_month', type: 'varchar', length: 30, nullable: true })
    factoryAnswerPrdMonth: string;

    @Column({ name: 'factory_answer_ng_reason_1', type: 'varchar', length: 30, nullable: true })
    factoryAnswerNgReason1: string;

    @Column({ name: 'factory_answer_ng_reason_2', type: 'varchar', length: 30, nullable: true })
    factoryAnswerNgReason2: string;

    @Column({ name: 'factory_answer_free_comment', type: 'varchar', length: 30, nullable: true })
    factoryAnswerFreeComment: string;

    @Column({ name: 'factory_answer_answer_user', type: 'varchar', length: 30, nullable: true })
    factoryAnswerAnswerUser: string;

    @Column({ name: 'factory_answer_answer_date', type: 'varchar', length: 30, nullable: true })
    factoryAnswerAnswerDate: string;

    @Column({ name: 'order_decision_decision', type: 'varchar', length: 30, nullable: true })
    orderDecisionDecision: string;

    @Column({ name: 'order_decision_order_qty', type: 'varchar', length: 30, nullable: true })
    orderDecisionOrderQty: string;

    @Column({ name: 'order_decision_air_use', type: 'varchar', length: 30, nullable: true })
    orderDecisionAirUse: string;

    @Column({ name: 'dl_yarn_order_qty', type: 'int', nullable: true })
    dlYarnOrderQty: number;

    @Column({ name: 'dl_yarn_order_number', type: 'int', nullable: true })
    dlYarnOrderNumber: number;

    @Column({ name: 'dl_yarn_plan', type: 'varchar', nullable: true })
    dlYarnPlan: string;

    @Column({ name: 'dl_yarn_actual', type: 'varchar', nullable: true })
    dlYarnActual: string;

    @Column({ name: 'dl_fabric_order_qty', type: 'int', nullable: true })
    dlFabricOrderQty: number;

    @Column({ name: 'dl_fabric_order_number', type: 'varchar', length: 30, nullable: true })
    dlFabricOrderNumber: number;

    @Column({ name: 'dl_fabric_plan', type: 'varchar', length: 30, nullable: true })
    dlFabricPlan: string;

    @Column({ name: 'dl_fabric_actual', type: 'varchar', length: 30, nullable: true })
    dlFabricActual: string;

    @Column({ name: 'dl_color_order_qty', type: 'varchar', length: 30, nullable: true })
    dlColorOrderQty: string;

    @Column({ name: 'dl_color_order_number', type: 'int', nullable: true })
    dlColorOrderNumber: number;

    @Column({ name: 'dl_color_plan', type: 'varchar', length: 30, nullable: true })
    dlColorPlan: string;

    @Column({ name: 'dl_color_actual', type: 'varchar', nullable: true })
    dlColorActual: string;

    @Column({ name: 'dl_trim_order_qty', type: 'int', nullable: true })
    dlTrimOrderQty: number;

    @Column({ name: 'dl_trim_order_number', type: 'varchar', length: 30, nullable: true })
    dlTrimOrderNumber: number;

    @Column({ name: 'dl_trim_plan', type: 'varchar', length: 30, nullable: true })
    dlTrimPlan: string;

    @Column({ name: 'dl_trim_actual', type: 'varchar', length: 30, nullable: true })
    dlTrimActual: string;

    @Column({ name: 'dl_po_order_qty', type: 'int', nullable: true })
    dlPoOrderQty: number;

    @Column({ name: 'dl_po_order_number', type: 'int', nullable: true })
    dlPoOrderNumber: number;

    @Column({ name: 'dl_po_plan', type: 'varchar', length: 30, nullable: true })
    dlPoPlan: string;

    @Column({ name: 'dl_po_actual', type: 'varchar', length: 30, nullable: true })
    dlPoActual: string;

    @Column({ name: 'factory_answer_jdg_rslt_first_time', type: 'varchar', length: 30, nullable: true })
    factoryAnswerJdgRsltFirstTime: string;

    @Column({ name: 'factory_answer_ng_reason_1_first_time', type: 'varchar', length: 30, nullable: true })
    factoryAnswerNgReason1FirstTime: string;

    @Column({ name: 'factory_answer_ng_reason_2_first_time', type: 'varchar', length: 30, nullable: true })
    factoryAnswerNgReason2FirstTime: string;

    @Column({ name: 'factory_answer_free_comment_first_time', type: 'varchar', length: 30, nullable: true })
    factoryAnswerFreeCommentFirstTime: string;

    @OneToOne(() => PARequestListEntity, paRequestId => paRequestId.paRequestChildId)
    @JoinColumn({ name: 'pa_request_id', referencedColumnName: 'requestId' })
    paRequestId: PARequestListEntity;
}   